import { render, staticRenderFns } from "./post-gallery.vue?vue&type=template&id=18ff5afc&"
import script from "./post-gallery.vue?vue&type=script&lang=js&"
export * from "./post-gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ff5afc')) {
      api.createRecord('18ff5afc', component.options)
    } else {
      api.reload('18ff5afc', component.options)
    }
    module.hot.accept("./post-gallery.vue?vue&type=template&id=18ff5afc&", function () {
      api.rerender('18ff5afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/post/gallery/post-gallery.vue"
export default component.exports